import {Component, OnInit} from '@angular/core';
import {PhotographerService} from '../../services/photographer/photographer.service';
import {Photographer} from '../../entities/photographer/photographer.entity';
import {ActivatedRoute} from '@angular/router';
import {HeaderComponent} from '../../components/header/header.component';
import {PhotographerProfile} from '../../components/photographer/photographer-profile/photographer-profile';
import {PhotographerServices} from '../../components/photographer/photographer-services/photographer-services';
import {PhotographerPortfolio} from '../../components/photographer/photographer-portfolio/photographer-portfolio';
import {PortfolioPhoto} from '../../../core/entities/portfolio/portfolio-photo.entity';
import {PortfolioService} from '../../services/portfolio/portfolio.service';
import {SeoService} from '../../../core/services/seo/seo.service';
import {
  PhotographerBookNowModal
} from '../../../creator/components/photographer-book-now-modal/photographer-book-now-modal';

@Component({
  selector: 'app-photographe',
  imports: [
    HeaderComponent,
    PhotographerProfile,
    PhotographerServices,
    PhotographerPortfolio,
    PhotographerBookNowModal,
  ],
  templateUrl: './photographer.component.html',
  standalone: true,
  styleUrl: './photographer.component.scss'
})
export class PhotographerComponent implements OnInit {
  public photographer: Photographer|null = null;
  public portfolio: PortfolioPhoto[]|null = null;
  public loading = false;
  public bookNowModalOpened = false;

  public constructor(
    private readonly photographerService: PhotographerService,
    private readonly portfolioService: PortfolioService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly seoService: SeoService,
  ) {
  }

  public ngOnInit() {
    this.loading = true;
    this.activatedRoute.paramMap.subscribe((params) => {
      const slug = params.get('slug');
      if (slug) {
        this.photographerService.getPhotographer(slug).subscribe(
          (photographer) => {
            photographer.services = photographer.services.sort((a, b) => a.position - b.position);
            this.photographer = photographer;
            this.seoService.setupSEOForPhotographer(this.photographer);
            this.portfolioService.getPortfolio(this.photographer.id).subscribe(
              (portfolio) => (this.portfolio = portfolio),
            );
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            console.error('Error fetching photographer:', error);
          }
        );
      }
    });
  }

  public openBookNowModal(): void {
    this.bookNowModalOpened = true;
  }

  public closeBookNowModal(): void {
    this.bookNowModalOpened = false;
  }
}
